import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Filter, Interval, RestClientPaged } from '@elderbyte/ngx-starter'
import { environment } from '../../../../../environments/environment'
import { WorkCenterSchedule } from './work-center-schedule'

export class WorkCenterScheduleFilter {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static readonly WORK_CENTER_IDS_KEY = 'workCenterIds'

  public static readonly INTERVAL_KEY = 'interval'

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static workCenterId(workCenterId: string): Filter {
    return new Filter(this.WORK_CENTER_IDS_KEY, workCenterId)
  }

  public static interval(interval: Interval): Filter {
    return new Filter(this.INTERVAL_KEY, interval.toInstantString())
  }
}

@Injectable({
  providedIn: 'root',
})
export class WorkCenterScheduleService extends RestClientPaged<WorkCenterSchedule, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/work-centers/work-schedules', http, {
      idField: 'id',
    })
  }
}
